import { render, staticRenderFns } from "./ProductPageAppDesktop.vue?vue&type=template&id=62c820c7&scoped=true"
import script from "./ProductPageAppDesktop.vue?vue&type=script&lang=js"
export * from "./ProductPageAppDesktop.vue?vue&type=script&lang=js"
import style0 from "./ProductPageAppDesktop.vue?vue&type=style&index=0&id=62c820c7&prod&lang=less"
import style1 from "./ProductPageAppDesktop.vue?vue&type=style&index=1&id=62c820c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c820c7",
  null
  
)

export default component.exports